import { useCallback } from 'react';

import {
	type BulkUpdatePrivacyRequest,
	type BulkUpdatePrivacyResponse,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

type UseBulkUpdatePrivacyControllerProps = AssistanceServiceInjectedParams;

export type UseBulkUpdatePrivacyControllerResult = {
	bulkUpdatePrivacy: (payload: BulkUpdatePrivacyRequest) => Promise<BulkUpdatePrivacyResponse>;
};

/**
 * Returns a function to bulk update privacy for prompts via the assistance service POST /api/v2/prompts/bulk-update-privacy endpoint.
 */
export const useBulkUpdatePrivacyController: (
	props: Omit<AssistanceServiceInjectedParams, 'assistanceServiceInjectedParams'> &
		AssistanceServiceInputParam,
) => UseBulkUpdatePrivacyControllerResult = createHookWithAssistanceService(
	({
		assistanceServiceInjectedParams: { assistanceService },
	}: UseBulkUpdatePrivacyControllerProps): UseBulkUpdatePrivacyControllerResult => {
		const bulkUpdatePrivacy = useCallback(
			(payload: BulkUpdatePrivacyRequest) => assistanceService.bulkUpdatePrivacy(payload),
			[assistanceService],
		);
		return { bulkUpdatePrivacy };
	},
);
